var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('video',{ref:"video",attrs:{"autoplay":"","width":_vm.width,"height":_vm.height}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }